import { MediaContentDTO } from "@touche-lts/panel-ui/dist";

export enum OrdersPeriodFilter {
    WEEK = 'Past week',
    MONTH = 'Past month',
    YEAR = 'Past year'
}

// export interface OrderAttributes { // TODO-A Order details, this may changea after bd is ready
//     attributeName: string;
//     id: number;
//     name: string;
//     type: string;
//     value: string;
// }

// export interface OrderDetails { // TODO-A Order details, this may changea after bd is ready
//     name: string;
//     price: number;
//     attributes: OrderAttributes[];
// }
export interface UserOrdersDTO {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
}

export interface OrdersDTO {
    id: number;
    number: number
    date: string;
    price: number;
    orderStatus: string;
    erorrStatus: string;
    shop: number;
    externalId: number;
    user: UserOrdersDTO;
    itemsCount?:number
    store?: {
        images?: MediaContentDTO[],
        name?: string,
    },
    products: any; // TODO-A Order details. To add correct DTOs here later.
    // details: OrderDetails[]; // TODO-A Order details, this may changea after bd is ready
}